import { useQuery, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { getEntitlements } from "src/api/entitlement";
import { PassCategory } from "src/api/membership";
import { entitlementToPassContent } from "./utils/toPassContent";
const useEntitlementsQuery = (param)=>{
    let { productId , isLoggedIn , freepassOnly , selectedPurchaseOption , productHandoutType  } = param;
    return useQuery([
        "entitlements",
        productId,
        selectedPurchaseOption,
        freepassOnly,
        productHandoutType
    ], async ()=>{
        try {
            return await getEntitlements({
                // productId 를 주면 서버가 usable·unUsableReasons 로 이용 가능 여부를 판정해준다
                productId: String(productId),
                category: freepassOnly ? [
                    PassCategory.FreePass
                ] : [
                    PassCategory.Solvookplus,
                    PassCategory.Subscription,
                    PassCategory.Ticket
                ],
                // PurchaseOptionKey 의 'download_origin' 은 사용 로그 타입이 혼입된 값으로 이 경로에
                // 도달하지 않는다. 타입 분리는 후속 과제 (plan.md §4.1)
                purchaseOption: selectedPurchaseOption,
                // 도서처럼 자료 유형이 없으면 키째 빼 서버가 이 축을 판정하지 않게 한다
                ...productHandoutType && {
                    productHandoutType
                }
            });
        } catch (error) {
            var _error_response;
            // 보유 수단이 없을 때의 404 를 빈 목록으로 흡수한다. `/memberships` 가 같은 의미로
            // 404 를 주던 동작을 보수적으로 유지한 것 — 신규 API 스펙에는 404 가 없어 확인 후 제거 가능
            if (isAxiosError(error) && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 404) {
                return {
                    items: []
                };
            }
            throw error;
        }
    }, {
        keepPreviousData: true,
        // selectedPurchaseOption 은 스토어 초기값이 null 이고 부모(HandoutProductDetailView)의
        // effect 에서 세팅된다. 자식인 이 쿼리의 구독이 먼저 실행돼 옵션 없이 요청이 한 번 나가므로
        // 옵션이 준비된 뒤에만 켠다
        enabled: isLoggedIn && !!selectedPurchaseOption,
        retry: (failureCount, error)=>{
            var _error_response;
            if (isAxiosError(error) && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 404) {
                return false;
            }
            return failureCount < 3;
        },
        select: (data)=>data.items.map(entitlementToPassContent)
    });
};
export const useInvalidateEntitlementsQuery = ()=>{
    const queryClient = useQueryClient();
    return (productId)=>{
        queryClient.invalidateQueries({
            queryKey: [
                "entitlements",
                productId
            ]
        });
    };
};
export default useEntitlementsQuery;
